/* Industry Single Page Tool Tab container */
document.addEventListener('DOMContentLoaded', function() {
  const toolsTabNavigation = document.querySelectorAll('.tab-navigation-interface button');


  if (toolsTabNavigation.length) {
    toolsTabNavigation.forEach(button => {
      button.addEventListener('click', function() {
        // Remove active class from siblings and add to current button
        const siblings = Array.from(this.parentNode.children).filter(child => child !== this);
        siblings.forEach(sibling => sibling.classList.remove('active'));
        this.classList.add('active');
        
        // Get index of current button
        const index = Array.from(this.parentNode.children).indexOf(this);
        
        // Find content items and update active state
        const tabRow = this.closest('.tab-row');
        const contentGroup = tabRow.nextElementSibling.querySelectorAll('.item');
        
        contentGroup.forEach(item => {
          item.classList.remove('active');
          item.classList.remove('in');
        });
        
        if (contentGroup[index]) {
          contentGroup[index].classList.add('active');
          contentGroup[index].classList.add('in');
        }
      });
    });
  }
});